import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '@tytapp/user';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit {

  constructor(
    private userService : UserService,
    private router : Router
  ) { }

  ngOnInit() {
    setTimeout(() => {
      this.userService.completeLogout();
      this.userService.user = null;
      this.router.navigate(['home']);
    })
  }

}
